// ------------------------------------ single product tab ----------------------------//

 jQuery(document).ready(function () {

    jQuery('.tab').on('click', function () {
      var target = jQuery(this).data('tab');
      jQuery('.tab').removeClass('active');
      jQuery(this).addClass('active');
      jQuery('.tab-content').removeClass('active');
      jQuery('#' + target).addClass('active');
    });

  
    jQuery('.accordion-header').on('click', function () {
      var parent = jQuery(this).parent();

      if (parent.hasClass('active')) {
        parent.removeClass('active');
        jQuery(this).find('.icon').text('+');
        jQuery(this).next('.accordion-body').slideUp(300);
      } else {
        jQuery('.accordion-item').removeClass('active');
        jQuery('.accordion-item .icon').text('+');
        jQuery('.accordion-body').slideUp(300);

        parent.addClass('active');
        jQuery(this).find('.icon').text('−');
        jQuery(this).next('.accordion-body').slideDown(300);
      }
    });
  });

// ------------------------ review slider -----------------------------//
 const reviewSlider = new Swiper('.reviews-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        centeredSlides: false,
      },
      576: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      768: {
        slidesPerView: 3,
         centeredSlides: false,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });
// ------------------------ review slider -----------------------------//


//-------------------------new spotlight slider ---------------------------//

// Initialize the new spotlight slider
const spotlightSlider = new Swiper(".new-spotlight-slider.swiper ", {
  effect: "coverflow",
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 2,
  spaceBetween: 30,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3.1,
    slideShadows: false,
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
  on: {
    slideChange: function () {
      // Pause the video of the previous slide when slide changes
      const previousSlide = this.slides[this.previousIndex];
      const previousVideo = previousSlide.querySelector("video");
      if (previousVideo) {
        previousVideo.pause();
        previousVideo.currentTime = 0;
      }

      // Get the video in the new active slide and start playing it
      const activeSlide = this.slides[this.activeIndex];
      const activeVideo = activeSlide.querySelector("video");
      if (activeVideo) {
        activeVideo.play();
        // Listen for the video end event to change the slide
        activeVideo.addEventListener("ended", () => {
          this.slideNext(); // Move to the next slide after video ends
        });
      }
    },
  },
});

// Pause autoplay on hover, resume on leave
const spotlightSliderContainer = document.querySelector(".new-spotlight-slider");

if (spotlightSliderContainer) {
  spotlightSliderContainer.addEventListener("mouseenter", () => {
    spotlightSlider.autoplay.stop();
  });

  spotlightSliderContainer.addEventListener("mouseleave", () => {
    spotlightSlider.autoplay.start();
  });
}

// Autoplay video of the first slide when page loads
document.addEventListener("DOMContentLoaded", function () {
  const firstSlide = spotlightSlider.slides[spotlightSlider.activeIndex];
  const firstVideo = firstSlide.querySelector("video");
  if (firstVideo) {
    firstVideo.play();
    // Listen for the video end event to change the slide after the first video ends
    firstVideo.addEventListener("ended", () => {
      spotlightSlider.slideNext(); // Move to the next slide after first video ends
    });
  }
});

// ------------------------- New Spotlight Slider --------------------------- //

//-------------------------spotlight slider ---------------------------//

const swiper = new Swiper(".spotlight-slider", {
  effect: "coverflow",
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 2, 
  spaceBetween: 30,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3.1,
    slideShadows: false,
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
// });


// // ✅ Pause autoplay on hover, resume on leave
// const swiperContainer = document.querySelector(".spotlight-slider");

// if (swiperContainer) {
//   swiperContainer.addEventListener("mouseenter", () => {
//     swiper.autoplay.stop();
//   });

//   swiperContainer.addEventListener("mouseleave", () => {
//     swiper.autoplay.start();
//   });
// }
  on: {
    slideChange: function () {
      // Pause the video of the previous slide when slide changes
      const previousSlide = this.slides[this.previousIndex];
      const previousVideo = previousSlide.querySelector("video");
      if (previousVideo) {
        previousVideo.pause();
        previousVideo.currentTime = 0; // Reset video playback
      }

      // Get the video in the new active slide and start playing it
      const activeSlide = this.slides[this.activeIndex];
      const activeVideo = activeSlide.querySelector("video");
      if (activeVideo) {
        activeVideo.play();
        // Listen for the video end event to change the slide
        activeVideo.addEventListener("ended", () => {
          this.slideNext(); // Automatically move to next slide after video ends
        });
      }
    },
  },
});

// ✅ Pause autoplay on hover, resume on leave
const swiperContainer = document.querySelector(".spotlight-slider");

if (swiperContainer) {
  swiperContainer.addEventListener("mouseenter", () => {
    swiper.autoplay.stop();
  });

  swiperContainer.addEventListener("mouseleave", () => {
    swiper.autoplay.start();
  });
}
//-------------------------spotlight slider ---------------------------//
window.onload = function () {
  var wishlistDiv = document.querySelector('[data-block-handle="product_wishlist"]');
  var wishlistUL = wishlistDiv?.nextElementSibling;

  if (
    wishlistDiv &&
    wishlistUL &&
    wishlistUL.classList.contains("icon-with-text")
  ) {
    var wrapper = document.createElement("div");
    wrapper.className = "wwici__wishlist_notice";

    // Insert wrapper before wishlistDiv
    wishlistDiv.parentNode.insertBefore(wrapper, wishlistDiv);

    // Move both wishlistDiv and wishlistUL inside the wrapper
    wrapper.appendChild(wishlistDiv);
    wrapper.appendChild(wishlistUL);
  }
};

// --------------------------------- Wrap the review and iconbox section on home page----------------------//
document.addEventListener("DOMContentLoaded", function () {
  const carouselSection = document.querySelector(".template-index section:has(.jdgm-carousel-wrapper)");
  const statsSection = document.querySelector(".template-index section:has(.stats-wrapper)");

  if (carouselSection && statsSection) {
    // Create the wrapper
    const wrapper = document.createElement("div");
    wrapper.className = "unified-bg-wrapper";

    // Insert wrapper before the first section
    carouselSection.parentNode.insertBefore(wrapper, carouselSection);

    // Move both sections into the wrapper
    wrapper.appendChild(carouselSection);
    wrapper.appendChild(statsSection);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const carouselSection2 = document.querySelector(".template-product section:has(.bamboo-fabric-section)");
  const statsSection2 = document.querySelector(".template-product section:has(.stats-wrapper)");

  if (carouselSection2 && statsSection2) {
    // Create the wrapper
    const wrapper2 = document.createElement("div");
    wrapper2.className = "unified-bg-wrapper";

    // Insert wrapper2 before the first section
    carouselSection2.parentNode.insertBefore(wrapper2, carouselSection2);

    // Move both sections into the wrapper2
    wrapper2.appendChild(carouselSection2);
    wrapper2.appendChild(statsSection2);
  }
});

// --------------------------------- Change the placholder for search input on mobile----------------------//

function updatePlaceholder() {
  const input = document.querySelector('.wwici-search-input');
  if (input) {
    if (window.innerWidth < 589) {
      input.placeholder = "Search";
    } else {
      input.placeholder = "Search for products, categories...";
    }
  }
}

// Run once when DOM is loaded
window.addEventListener('DOMContentLoaded', updatePlaceholder);

// Run on window resize
window.addEventListener('resize', updatePlaceholder);


// ------------------------------------------- Add Main Collection Class to Menu ------------------------------------------//

window.onload = function () {
  setTimeout(function () {
    const uls = document.querySelectorAll('ul.huk_menu_submenu');
    uls.forEach(ul => {
      if (ul.querySelector('.li-main-collection')) {
        ul.classList.add('has-main-collection');
      }
    });
  }, 1000); // 1 second delay
};
// Popup